module.exports = __webpack_public_path__ + "img/lightLava.a8802f03.png";